module.exports = __webpack_public_path__ + "img/no-issues.03e043d8.png";